import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NetPromoterScoreModalService } from '@core/components/net-promoter-score-modal/net-promoter-score-modal.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'app-net-promoter-score-modal',
  templateUrl: './net-promoter-score-modal.component.html',
  styleUrls: ['./net-promoter-score-modal.component.scss']
})
export class NetPromoterScoreModalComponent implements OnInit {
  public stepIndex = 1;
  public step = 'score-step';
  public netPromoterScoreForm: FormGroup;

  constructor(
    private readonly netPromoterScoreModalService: NetPromoterScoreModalService,
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.netPromoterScoreForm = new FormGroup({
      score: new FormControl(-1),
      comment: new FormControl(null)
    });
  }
  ngOnInit(): void {

  }

  public nextStep(event): void {
    if (event.nextStep === 'comment-step') {
      this.step = event.nextStep;
      this.netPromoterScoreForm.get('score').setValue(event.score);
      this.stepIndex = 2;
    }
    if (event.nextStep === 'final-step') {
      this.step = event.nextStep;
      this.netPromoterScoreForm.get('comment').setValue(event.comment);
      this.stepIndex = 3;
      this.netPromoterScoreModalService.saveNPS(this.netPromoterScoreForm.get('score').value, this.netPromoterScoreForm.get('comment').value);
    }
    if (event.nextStep === 'close') {
      this.netPromoterScoreModalService.close();
    }
  }

  public previousStep(): void {
      this.step = 'score-step';
      this.stepIndex = 1;
  }
}
